import * as React from "react";

import { NavOffsetSync } from "@/components/nav/nav-offset-sync";
import { cn } from "@/lib/utils";

export function ContentLayout({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <div className={cn("flex-1", className)}>{children}</div>;
}

export function PageLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex min-h-screen flex-col">
      <NavOffsetSync />
      {children}
    </div>
  );
}
